import api from './api';

const d = (r) => r.data;
const B = '/api/bulletins';

export const bulletinsAPI = {
  meta: () => api.get(`${B}/meta`).then(d),
  list: (params) => api.get(B, { params }).then(d),
  dashboard: () => api.get(`${B}/dashboard`).then(d),
  create: (body) => api.post(B, body).then(d),
  update: (id, body) => api.put(`${B}/${id}`, body).then(d),
  preview: (url) => api.post(`${B}/preview-link`, { url }).then(d),
  read: (id) => api.post(`${B}/${id}/read`).then(d),
  status: (id, status) => api.post(`${B}/${id}/status`, { status }).then(d),
  keyDate: (id, body) => api.post(`${B}/${id}/key-dates`, body).then(d),
  task: (id) => api.post(`${B}/${id}/task`).then(d),
  settings: () => api.get(`${B}/settings/config`).then(d),
  saveSettings: (body) => api.put(`${B}/settings/config`, body).then(d),
  fetchNow: () => api.post(`${B}/settings/fetch-now`).then(d),
  drafts: (params) => api.get(`${B}/content/drafts`, { params }).then(d),
  createDraft: (bid, body) => api.post(`${B}/${bid}/drafts`, body).then(d),
  editDraft: (id, body) => api.put(`${B}/content/drafts/${id}`, body).then(d),
  draftAction: (id, action, reason = '') => api.post(`${B}/content/drafts/${id}/action`, { action, reason }).then(d),
};

export const dspHubAPI = {
  readiness: () => api.get('/api/dsp-hub/readiness').then(d),
  area: (key) => api.get(`/api/dsp-hub/areas/${key}`).then(d),
  report: () => api.get('/api/dsp-hub/report.pdf', { responseType: 'blob' }).then(d),
};

export const qmsAPI = { dashboard: () => api.get('/api/qms/dashboard').then(d) };

export const errMsg = (e) => {
  const det = e?.response?.data?.detail;
  if (Array.isArray(det)) return det.map((x) => x.msg).join('; ');
  return det || e?.message || 'Something went wrong';
};

export const saveBlob = (blob, name) => { const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = name; a.click(); };
